import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
const PostpaidPlans = ({ onClose, onSelectPlan }) => {
  const [selectedCategory, setSelectedCategory] = useState("Full Talktime");
 const plans = {
    "Full Talktime": [
      {
    validity: "3 days",
    amount: 48,
    description: [
      "Subscription to JioGames Cloud",
      "Validity - 3 days"
    ]
  },
  {
    validity: "7 days",
    amount: 98,
    description: [
      "Subscription to JioGames Cloud",
      "Validity - 7 days"
    ]
  }
    ],
    "Top Up Recharge": [
      {
        validity: "NA",
        amount: 10,
        description: ["Talktime: ₹7.47"]
      },
      {
        validity: "NA",
        amount: 20,
        description: ["Talktime: ₹14.95"]
      }
    ],
    "3G/4G Data": [
      {
        validity: "1 day",
        amount: 11,
        description: [
          "Unlimited Data (10GB High Speed, then 64Kbps)",
          "Validity: 1 Hour"
        ]
      },
      {
        validity: "1 day",
        amount: 19,
        description: [
          "Unlimited Data (1GB High Speed, then 64Kbps)",
          "Validity: 1 Day"
        ]
      }
    ],
    Combo: [],
    "2G Data": [
        {
    validity: "28 days",
    amount: 26,
    description: [
      "Description :  JioPhone Data Add-on - Benefits: UNLIMITED DATA - LOWSPEEDDATAB",
       "Validity - 28 days",
       "Only for JioPhones "
    ]
  },
  {
    validity: "28 days",
    amount: 62,
    description: [
      "Description :  JioPhone Data Add-on - Benefits: UNLIMITED DATA - 6GB",
       "Validity - 28 days",
       "Only for JioPhones "
    ]
  }
    ],
    "Rate Cutter": [
      {
        validity: "30 days",
        amount: 99,
        description: [
          "Description : JioSaavn Pro - Benefits: JIO SAVAN PRO",
          "Validity - 30 days",
          "Note - To Activate JioSaavn Premium Monthly Subscription visit JioSaavn App."
        ]
      },
      {
        validity: "90 days",
        amount: 100,
        description: [
          "Entertainment Plans - Benefits: 5 GB 4G/5G Data thereafter unlimited at 64 kbps, Jio Hotstar 3 months Subscription",
          "Validity - 90 days.",
          "Note - To Activate Jio Hotstar Subscription: 1) Download the Jio Hotstar app. 2) LOG IN using OTP from your eligible Jio number.",
          "For more details click http://tiny.jio.com/r457tjI T&C Apply."
        ]
      }
    ],
    SMS: [],
    "Roaming": [
        {
        validity: "7 days",
        amount: 39,
        description: [
          "Description :  ISD - Benefit - 30 Minutes calls to USA & Canada." ,
          "Validity - 7 Days"
        ]
      },
      {
        validity: "47 days",
        amount: 100,
        description: [
          "Description :  ISD - Benefit - 15 Minutes ISD calls to Bangladesh.",
          "Validity - 7 Days" 
        ]
      }
    ]
  };
  const categories = Object.keys(plans);
  const selectedPlans = plans[selectedCategory];
  const noPlans = !selectedPlans || selectedPlans.length === 0;
  const handleRechargeClick = (plan) => {
    onSelectPlan(plan.amount, plan.description);
  };
  return (
    <div className="ds-card p-4 sm:p-6 mb-2 w-full">
  <div className="flex justify-between items-center">
    <h2 className="text-base sm:text-xl font-semibold text-[var(--text-dark)]">
      Browse Plans
    </h2>
    <button onClick={onClose} className="text-[var(--error-color)] font-semibold">
      <CloseIcon fontSize="small" />
    </button>
  </div>
  <div className="flex flex-nowrap overflow-x-auto gap-2 mt-4 border-b border-[var(--border-color)] pb-2">
    {categories.map((category) => (
      <button
        key={category}
        onClick={() => setSelectedCategory(category)}
        className={`px-2 py-1 text-[10px] sm:text-xs whitespace-nowrap rounded transition ${
          selectedCategory === category
            ? "ds-btn ds-btn-primary"
            : "bg-[var(--bg-app)] text-[var(--text-muted)] hover:opacity-80"
        }`}>
        {category}
      </button>
    ))}
  </div>
  <h3 className="mt-4 text-xs sm:text-sm font-semibold text-[var(--text-muted)]">
    {selectedCategory}
  </h3>
  {noPlans ? (
    <p className="text-center text-[var(--text-muted)] mt-4">
      No plans found in this category
    </p>
  ) : (
    <div className="space-y-3 mt-4">
      {selectedPlans.map((plan, index) => (
        <div
          key={index}
          className="border border-[var(--border-color)] rounded-lg p-3 flex flex-col sm:flex-row sm:justify-between sm:items-start gap-3">
          <div className="text-center sm:w-20">
            <p className="text-[10px] sm:text-xs text-[var(--text-muted)]">Validity</p>
            <p className="font-bold text-sm sm:text-base text-[var(--text-dark)]">{plan.validity}</p>
          </div>
          <div className="flex-1">
            <p className="font-semibold text-sm sm:text-base text-[var(--text-dark)]">
              Amount :
              <span className="text-[var(--error-color)]"> ₹{plan.amount}</span>
            </p>
            <p className="text-[11px] sm:text-sm font-semibold text-[var(--text-muted)] mt-1">
              Description :
            </p>
            <ul className="text-[var(--text-muted)] text-[11px] sm:text-sm list-disc ml-4 sm:ml-5">
              {plan.description.map((line, i) => (
                <li key={i}>{line}</li>
              ))}
            </ul>
          </div>
          <button
            onClick={() => handleRechargeClick(plan)}
            className="ds-btn ds-btn-primary w-full sm:w-auto text-xs sm:text-sm">
            Select Plan
          </button>
        </div>
      ))}
    </div>
  )}
</div>
  );
};
export default PostpaidPlans;
